
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingNotesV3.html?raw';
import { EvBookingCopyForm } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import Edit from '../../../moreCore/UI/Edit/Edit';
import "../../../moreCore/UI/Edit/Edit";
class EvBookingNotesV3 extends compose(_StatefulSection) {
    templateString: any = template;

    noteInternInput_section: HTMLElement;
    private noteInput: MdsLax<InstanceType<typeof Edit>>;

    afterSetData() {
        let data = this.sourceData as VAM2types.EvBooking_Base;
    }

    onDirtyChange(currentState: boolean) {
        
    }

    _onChanged(key: string, value: any) {

    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.hideNode(this.noteInternInput_section, !this.hasFeature("EvBooking/NoteIntern"));
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingNotesV3);